<template>
  <div class="page admin-page">
    <div class="container">
      <div class="header">
        <h1><span>📊</span> 考试管理</h1>
        <div style="display: flex; align-items: center; gap: 20px;">
          <span class="user-info">👤 {{ currentUser.realName || '加载中...' }}</span>
          <button class="logout-btn" @click="goBack">返回首页</button>
        </div>
      </div>

      <div class="actions">
        <button class="btn btn-primary" @click="showCreateForm = !showCreateForm">
          {{ showCreateForm ? '取消创建' : '➕ 创建考试' }}
        </button>
        <button class="btn btn-success" @click="loadExams">
          🔄 刷新列表
        </button>
      </div>

      <div v-if="showCreateForm" class="form-container">
        <div class="form-item">
          <label>学员ID</label>
          <input v-model="newExam.userId" placeholder="请输入学员ID">
        </div>
        <div class="form-item">
          <label>案例ID</label>
          <input v-model="newExam.caseId" placeholder="请输入案例ID">
        </div>
        <div style="grid-column: 1 / -1;">
          <button class="btn btn-primary" @click="createExam" :disabled="loading">
            {{ loading ? '创建中...' : '✅ 确认创建' }}
          </button>
        </div>
      </div>

      <div class="list-container">
        <div v-if="loading" class="loading">
          <div class="spinner"></div>
          <p style="margin-top: 12px;">加载中...</p>
        </div>

        <div v-else-if="exams.length === 0" class="empty-state">
          <div class="empty-icon">📊</div>
          <p>暂无考试,点击上方"创建考试"开始</p>
        </div>

        <div v-else>
          <div v-for="item in exams" :key="item.id" class="exam-item">
            <div class="exam-title">考试ID:{{ item.id }}</div>
            <div class="exam-desc">
              学员ID:{{ item.userId }} | 案例ID:{{ item.caseId }}
            </div>
            <div class="exam-meta">
              <span>状态:{{ item.status === 0 ? '进行中' : item.status === 1 ? '已完成' : '已评分' }}</span>
              <span>得分:{{ item.score || 0 }} 分</span>
              <span>创建时间:{{ formatTime(item.createdTime) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Exams',
  data() {
    return {
      currentUser: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      exams: [],
      newExam: { userId: '', caseId: '' },
      showCreateForm: false,
      loading: false
    }
  },
  mounted() {
    this.loadExams()
  },
  methods: {
    async loadExams() {
      this.loading = true
      try {
        // 管理员查询所有考试记录
        const response = await axios.get('/api/exams/all')
        if (response.data && response.data.code === 200) {
          this.exams = response.data.data || []
        }
      } catch (error) {
        console.error('加载考试失败:', error)
        alert('加载失败:' + (error.response?.data?.message || error.message))
      } finally {
        this.loading = false
      }
    },
    async createExam() {
      if (!this.newExam.userId || !this.newExam.caseId) {
        alert('请填写完整信息')
        return
      }

      this.loading = true
      try {
        const response = await axios.post('/api/exams', this.newExam)
        if (response.data && response.data.code === 200) {
          alert('创建成功!考试ID:' + response.data.data.id)
          this.newExam = { userId: '', caseId: '' }
          this.showCreateForm = false
          await this.loadExams()
        }
      } catch (error) {
        console.error('创建考试失败:', error)
        alert('创建失败:' + (error.response?.data?.message || error.message))
      } finally {
        this.loading = false
      }
    },
    goBack() {
      this.$router.push('/home')
    },
    formatTime(time) {
      if (!time) return '未知时间'
      return new Date(time).toLocaleString()
    }
  }
}
</script>

<style scoped>
.page {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  background: linear-gradient(135deg, #0c0c1d 0%, #1a1a2e 100%);
  min-height: 100vh;
  width: 100vw;
  padding: 20px;
  color: #fff;
  overflow-x: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 24px 30px;
  background: rgba(255,255,255,0.03);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.1);
  animation: slideDown 0.5s ease-out;
}

@keyframes slideDown {
  from { opacity:0; transform: translateY(-20px); }
  to { opacity:1; transform: translateY(0); }
}

.header h1 {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 2px;
}

.header h1 span {
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.user-info {
  color: rgba(255,255,255,0.7);
  font-size: 14px;
}

.logout-btn {
  padding: 10px 24px;
  background: rgba(255,255,255,0.05);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.logout-btn:hover {
  background: rgba(255,255,255,0.1);
}

.actions {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
  padding: 20px;
  background: rgba(255,255,255,0.03);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.1);
  animation: fadeIn 0.6s ease-out 0.2s both;
}

@keyframes fadeIn {
  from { opacity:0; }
  to { opacity:1; }
}

.btn {
  padding: 12px 28px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: '';
  position: absolute;
  top:0;
  left:-100%;
  width:100%;
  height:100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.btn:hover::before {
  left: 100%;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102,126,234,0.4);
}

.btn-success {
  background: linear-gradient(135deg, #11998e, #38ef7d);
  color: white;
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(56,239,125,0.4);
}

.form-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 30px;
  padding: 24px;
  background: rgba(255,255,255,0.03);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.1);
}

.form-item {
  margin-bottom: 16px;
}

.form-item label {
  display: block;
  font-size: 14px;
  color: rgba(255,255,255,0.7);
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.form-item input {
  width: 100%;
  padding: 12px 16px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  transition: all 0.3s;
  outline: none;
}

.form-item input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102,126,234,0.2);
  background: rgba(102,126,234,0.05);
}

.list-container {
  padding: 24px;
  background: rgba(255,255,255,0.03);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.1);
  animation: fadeIn 0.6s ease-out 0.4s both;
}

.exam-item {
  padding: 24px;
  margin-bottom: 20px;
  background: rgba(255,255,255,0.02);
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.08);
  transition: all 0.3s;
}

.exam-item:hover {
  background: rgba(102,126,234,0.05);
  border-color: rgba(102,126,234,0.3);
  transform: translateX(8px);
}

.exam-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.exam-desc {
  color: rgba(255,255,255,0.5);
  font-size: 14px;
  line-height: 1.6;
}

.exam-meta {
  display: flex;
  gap:20px;
  margin-top:12px;
  color: rgba(255,255,255,0.3);
  font-size:12px;
}

.empty-state {
  text-align: center;
  padding:80px 20px;
  color: rgba(255,255,255,0.3);
}

.empty-icon {
  font-size:64px;
  margin-bottom:20px;
}

.loading {
  text-align: center;
  padding:40px;
}

.spinner {
  display: inline-block;
  width:24px;
  height:24px;
  border:3px solid rgba(102,126,234,0.3);
  border-top-color:#667eea;
  border-radius:50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
